import { render } from "./ErrorNotification.vue?vue&type=template&id=13f95b04"
import script from "./ErrorNotification.vue?vue&type=script&lang=js"
export * from "./ErrorNotification.vue?vue&type=script&lang=js"
script.render = render

export default script